module.exports = __webpack_public_path__ + "img/logo-american-express-256.cf34e598.png";